import { useCallback, useMemo } from "react";

import type { PackingListRow } from "@RequestFormV2/sections/PackingList/types";
import { isPackingListFieldRequired } from "@RequestFormV2/validation/sections/packingListFieldRules";
import { useIsParcelFreight } from "@RequestFormV2/sections/PackingList/hooks/useIsParcelFreight";
import { usePackingListData } from "@RequestFormV2/sections/PackingList/context/usePackingListData";

export function usePackingListValidation() {
  const isParcelFreight = useIsParcelFreight();
  const { handlingUnitHashMap, packingListConfig } = usePackingListData();
  const nmfcNumberEnabled = packingListConfig?.nmfc_number_enabled;

  const isFieldRequired = useCallback(
    (row: PackingListRow, field: "dimensions" | "weight" | "units" | "nmfc" | "additional_information") =>
      isPackingListFieldRequired(row, field, handlingUnitHashMap, { nmfcNumberEnabled }),
    [handlingUnitHashMap, nmfcNumberEnabled],
  );

  return useMemo(
    () => ({
      isFieldRequired,
      isParcelFreight,
    }),
    [isFieldRequired, isParcelFreight],
  );
}
